import React, { useState,useRef,useEffect,useCallback } from 'react';
import { Typography, Button } from 'antd';
import styles from './index.module.scss';
import { useAppSelector } from '@/store/hooks';


const { Title } = Typography;


const AboutUs: React.FC = () => {
  
  
  return (
    <div className={styles['home-container']}>

    </div>
  );
};

export default AboutUs; 